import { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { styled } from "@glitz/react";
import Modal from "./basic/Modal";
import NewsletterSignup from "./NewsletterSignup";
import {
  markNewsletterDismissed,
  markNewsletterSubscribed,
  NEWSLETTER_MODAL_CONFIG,
  shouldShowNewsletterModal,
} from "../lib/newsletterModal";
import { fontSize, spacing, darkGrey, green, fontWeight } from "../theme";

const NewsletterModal = () => {
  const { pathname } = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    setIsOpen(false);

    if (!shouldShowNewsletterModal(pathname)) return;

    const timer = window.setTimeout(() => {
      setIsOpen(true);
    }, NEWSLETTER_MODAL_CONFIG.delayMs);

    return () => window.clearTimeout(timer);
  }, [pathname]);

  const handleClose = useCallback(() => {
    markNewsletterDismissed();
    setIsOpen(false);
  }, []);

  const handleSubscribe = useCallback(() => {
    markNewsletterSubscribed();
    setIsOpen(false);
  }, []);

  return (
    <Modal isOpen={isOpen} onClose={handleClose} title="Nyhetsbrev">
      <OfferText>
        Prenumerera och få <strong>10&nbsp;% rabatt</strong> på din första order.
      </OfferText>
      <Description>
        Få tips, erbjudanden och nyheter om triathlon direkt i inkorgen. Rabattkoden
        skickas till din e-post efter att du bekräftat prenumerationen.
      </Description>
      <NewsletterSignup variant="modal" onSubscribe={handleSubscribe} />
    </Modal>
  );
};

const OfferText = styled.p({
  fontSize: fontSize.l,
  lineHeight: 1.4,
  color: green,
  fontWeight: fontWeight.bold,
  margin: { bottom: spacing.s },
});

const Description = styled.p({
  fontSize: fontSize.m,
  lineHeight: 1.5,
  color: darkGrey,
  margin: { bottom: spacing.l },
});

export default NewsletterModal;
